import styled from "styled-components"
import Span from "../typography/span"

const Div = styled(Span).attrs(() => ({ as: "div" }))``

export default Div
